module.exports = "<svg class=\"toga-icon toga-icon--star\" xmlns=\"http://www.w3.org/2000/svg\" x=\"0px\" y=\"0px\" width=\"20px\" height=\"20px\" viewBox=\"0 0 20 20\"><polygon fill=\"#DDDDDD\" points=\"10,0 13.09,6.583 20,7.639 15,12.764 16.18,20 10,16.583 3.82,20 5,12.764 0,7.639 6.91,6.583 \"></polygon></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/lib/icons/star.svg
// module id = oHgk
// module chunks = 0